import React from "react";
import s from "./TableFooter.module.scss";

const TableFooter = ({ sections = [] }) => {
  const validSections = Array.isArray(sections)
    ? sections.filter((s) => s && s.infomation)
    : [];

  if (!validSections.length) return null;

  const resolveText = (section) => {
    if (typeof section?.infomation !== "string") return section?.infomation;
    return section.infomation.replaceAll("{key}", String(section.key ?? ""));
  };

  return (
    <div className={s.footer}>
      {validSections.map((section) => (
        <div key={section.key} className={s.section}>
          <span className={s.text}>{resolveText(section)}</span>
        </div>
      ))}
    </div>
  );
};

export default React.memo(TableFooter);
